const data = [
  {id: 0, name: '속씨식물군', parentId: null},
  {id: 1, name: '외떡잎식물아강', parentId: 0},
  {id: 2, name: '진정쌍떡잎식물아강', parentId: 0},
  {id: 3, name: '목련아강', parentId: 0},
  {id: 4, name: '백계피목', parentId: 3},
  {id: 5, name: '후추목', parentId: 3},
  {id: 6, name: '목련목', parentId: 3},
  {id: 7, name: '택사군', parentId: 1},
  {id: 8, name: '백합군', parentId: 1},
  {id: 9, name: '기저진정쌍떡잎식물군', parentId: 2},
  {id: 10, name: '핵심진정쌍떡잎식물군', parentId: 2},
  {id: 11, name: '미나리아재비목', parentId: 9},
  {id: 12, name: '프로테아목', parentId: 9},
  {id: 13, name: '수레나무목', parentId: 9},
  {id: 14, name: '장미군', parentId: 10},
  {id: 15, name: '국화군', parentId: 10},
  {id: 16, name: '이카키나목', parentId: 15},
  {id: 17, name: '용담목', parentId: 15},
  {id: 18, name: '가리야목', parentId: 15},
  {id: 19, name: '발리아목', parentId: 15},
  {id: 20, name: '가지목', parentId: 15},
  {id: 21, name: '꿀풀목', parentId: 15},
  {id: 22, name: '가지과', parentId: 20},
  {id: 23, name: '메꽃과', parentId: 20},
  {id: 24, name: '새삼과', parentId: 20},
  {id: 25, name: '레트지아과', parentId: 20},
  {id: 26, name: '조름나물과', parentId: 20},
  {id: 27, name: '흰독말풀', parentId: 22},
  {id: 28, name: '가지', parentId: 22},
  {id: 29, name: '맨드레이크', parentId: 22},
  {id: 30, name: '고추', parentId: 22},
  {id: 31, name: '감자', parentId: 22},
  {id: 32, name: '담배', parentId: 22},
  {id: 33, name: '토마토', parentId: 22}
]

export default data



// WEBPACK FOOTER //
// ./src/data.js